import { useEffect } from "react";
import StatusSolicitacao from "./StatusSolicitacao";
import { atualizarStatus } from "@store/slices/solicitacaoSlice";
import { useDispatch } from "react-redux";

function StatusSolicitacaoSection({ solicitacaoFields }) {

    const dispatch = useDispatch();

    useEffect(() => {
        if (solicitacaoFields?.numeroStatusSolicitacao) {
            dispatch(atualizarStatus({ id: solicitacaoFields.id, status: solicitacaoFields.numeroStatusSolicitacao }));
        }
    }, [solicitacaoFields?.numeroStatusSolicitacao, dispatch]);

    return (
        <div className="row mt-4">
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">

                            <StatusSolicitacao
                                idSolicitacao={solicitacaoFields?.id}
                                flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StatusSolicitacaoSection;